/**
 * @flow
 */
import React from 'react'
import Col from 'antd/lib/col'
import Table from 'antd/lib/table'
import Input from 'antd/lib/input'
import Icon from 'antd/lib/icon'
import Button from 'antd/lib/button'
import Popconfirm from 'antd/lib/popconfirm'
import message from 'antd/lib/message'
import { Link } from 'react-router-dom'
import get from 'lodash/get'
import { Tag } from 'antd';
import {
  ContentWrapper as Content,
  MarginedRow as Row,
} from '../../shared/styles'
import {
  CompanyQuery,Payment_logQuery,
  CompanyDeleteMutation,PaymentDeleteMutation
} from 'qgst-gql-queries/web/data.json'
import { gql, graphql, compose } from 'react-apollo'
import { ROUTES } from '../../shared/constants'
import { Button as B } from '../../shared/styles'
import ProfileSelModal from '../NF/Profile/ProfileModal'

import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
const { Column } = Table

//table develop
const add_button = { outline: '0', display: 'inline-block', marginBottom: '0', fontWeight: '500', textAlign: 'center', touchAction: 'manipulation', cursor: 'pointer', backgroundImage: 'none', border: '1px solid transparent', whiteSpace: 'nowrap', lineHeight: '1', padding: '2 15px', fontSize: '12px', borderRadius: '5px', height: '33px', mozUserSelect: 'none', position: 'relative', color: '#000000a6', backgroundColor: '#09537C', borderColor: '#d9d9d9', color: "white", alignItems: 'center' };


const edit_button = { display: 'flex', justifyContent: 'space-around', alignItems: 'center', outline: '0', display: 'inline-block', marginBottom: '0', marginRight: '5', textAlign: 'center', touchAction: 'manipulation', cursor: 'pointer', backgroundImage: 'none', border: '1px solid transparent', whiteSpace: 'nowrap', lineHeight: '1.80', padding: '0 15px', fontSize: '13px', borderRadius: '5px', height: '33px', mozUserSelect: 'none', position: 'relative', color: '#000000a6', backgroundColor: '#F3F3F3', borderColor: '#d9d9d9', width: '70px', marginRight: "8px", color: "black" };



const user_button = { outline: '0', display: 'inline-block', marginBottom: '0', marginRight: '5', textAlign: 'center', touchAction: 'manipulation', cursor: 'pointer', backgroundImage: 'none', border: '1px solid transparent', whiteSpace: 'nowrap', lineHeight: '1.80', padding: '0 15px', fontSize: '12px', borderRadius: '5px', height: '33px', mozUserSelect: 'none', position: 'relative', color: "black", backgroundColor: '#F3F3F3', borderColor: '#d9d9d9', width: '70px', marginRight: "8px", fontSize: '13px' };

const PaymentList = (props) =>
  <Content>
    <Row gutter={24}>
      <Col span="7">
        <Button style={add_button}>
          <Link to={ROUTES.PAYMENT_ADD}><span style={{ display: "table-caption" }}>Add Paid Customer</span></Link>
        </Button>
      </Col>
      <Col span="3">
      <Tag style={{ cursor: 'initial' }} color="green" icon="CheckCircleOutlined" >paid : {props.paid}</Tag>
      </Col>
      <Col span="3">
      <Tag style={{ cursor: 'initial' }} color="volcano" icon="CloseCircleOutlined">pending : {props.pending}</Tag>
      </Col>
      <Col span="6">
      <Tag style={{ cursor: 'initial' }} color="blue" icon="ClockCircleOutlined" >verify : {props.verify}</Tag>
      </Col>
    </Row>   
    <Table dataSource={props.formattedData} bordered rowKey="gstin">
      <Column title="GSTIN/UID" dataIndex="gstin" key="gstin" className="alignCenter"
        filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              placeholder="Search GSTN"
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={props.handleSearch(selectedKeys, confirm)}
            />
            <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
            <Button id="gstnSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
          </div>
        )}
        filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#3d85c6' }} />}
        onFilter={(value, record) => record.gstin.toLowerCase().includes(value.toLowerCase())}
        render={(text) => {
          return props.searchText ? (
            <span>
              {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                fragment.toLowerCase() === props.searchText.toLowerCase()
                  ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
              ))}
            </span>
          ) : text;
        }}
      />
      <Column title="Compay Name" dataIndex="name" key="name" className="alignCenter"
        filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              placeholder="Search Company Name"
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={props.handleSearch(selectedKeys, confirm)}
            />
            <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
            <Button id="gstnSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
          </div>
        )}
        filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#3d85c6' }} />}
        onFilter={(value, record) => record.name.toLowerCase().includes(value.toLowerCase())}
        render={(text) => {
          return props.searchText ? (
            <span>
              {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                fragment.toLowerCase() === props.searchText.toLowerCase()
                  ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
              ))}
            </span>
          ) : text;
        }}
      />
           <Column title="Email ID" dataIndex="email" key="email" className="alignCenter"
        filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              placeholder="Search Email ID"
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={props.handleSearch(selectedKeys, confirm)}
            />
            <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
            <Button id="emailSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
          </div>
        )}
        filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#3d85c6' }} />}
        onFilter={(value, record) => record.email.toLowerCase().includes(value.toLowerCase())}
        render={(text) => {
          return props.searchText ? (
            <span>
              {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                fragment.toLowerCase() === props.searchText.toLowerCase()
                  ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
              ))}
            </span>
          ) : text;
        }}
      />

<Column title="Phone Number" dataIndex="phone_number" key="phone_number" className="alignCenter"
        filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              placeholder="Search Phone Number"
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={props.handleSearch(selectedKeys, confirm)}
            />
            <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
            <Button id="phonenumSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
          </div>
        )}
        filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#3d85c6' }} />}
        onFilter={(value, record) => record.phone_number.toLowerCase().includes(value.toLowerCase())}
        render={(text) => {
          return props.searchText ? (
            <span>
              {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                fragment.toLowerCase() === props.searchText.toLowerCase()
                  ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
              ))}
            </span>
          ) : text;
        }}
      />

      <Column title="Payment date" className='alignCenter' dataIndex='payment_date' key='payment_date'
              filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div className="custom-filter-dropdown">
                  <Input
                    placeholder="Search payment date"
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={props.handleSearch(selectedKeys, confirm)}
                  />
                  <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
                  <Button id="paymentdtSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
                </div>
              )}
              filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#3d85c6' }} />}
              onFilter={(value, record) => record.payment_date.toLowerCase().includes(value.toLowerCase())}
              render={(text) => {
                return props.searchText ? (
                  <span>
                    {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                      fragment.toLowerCase() === props.searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                    ))}
                  </span>
                ) : text;
              }}
      
      />
      <Column title="Payment exprie date" className='alignCenter' dataIndex='expire_date' key='expire_date'
                    filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                      <div className="custom-filter-dropdown">
                        <Input
                          placeholder="Search expire date"
                          value={selectedKeys[0]}
                          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                          onPressEnter={props.handleSearch(selectedKeys, confirm)}
                        />
                        <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
                        <Button id="expiredtSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
                      </div>
                    )}
                    filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#3d85c6' }} />}
                    onFilter={(value, record) => record.expire_date.toLowerCase().includes(value.toLowerCase())}
                    render={(text) => {
                      return props.searchText ? (
                        <span>
                          {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                            fragment.toLowerCase() === props.searchText.toLowerCase()
                              ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                          ))}
                        </span>
                      ) : text;
                    }}
      
      
      />
      <Column title="Status" className='alignCenter' dataIndex='status' key='status'
                filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div className="custom-filter-dropdown">
                    <Input placeholder="Search status" value={selectedKeys[0]} onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])} onPressEnter={props.handleSearch(selectedKeys, confirm)}/>
                    <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
                    <Button id="statusSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
                 </div>
               )}
                filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#3d85c6' }} />}
                 onFilter={(value, record) => record.status.toLowerCase().includes(value.toLowerCase())}
                 render={text => {
                      let tag;
                     switch (text) {
                             case 'paid':
                                tag = <Tag style={{ cursor: 'initial' }} color="green">{text}</Tag>;
                                break;
                            case 'verify':
                                 tag = <Tag style={{ cursor: 'initial' }} color="blue">{text}</Tag>;
                                 break;
                            case 'Pending':
                                 tag = <Tag style={{ cursor: 'initial' }} color="volcano">{text}</Tag>;
                                 break;
                            default:
                                 tag = <Tag style={{ cursor: 'initial' }}>{text}</Tag>;
                          }

                       return props.searchText ? (
                           <span>
                             {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                               fragment.toLowerCase() === props.searchText.toLowerCase()
                               ? <span key={i} className="highlight">{fragment}</span> 
                               : fragment // eslint-disable-line
                               ))}
                           </span>
                         ) : tag;
     }}
/>


      {/* <Column title="Status" className='status alignCenter'  dataIndex='status' key='status'render={text => (text === 'paid' ? <Tag style={{ cursor: 'initial' }} color="green">{text}</Tag> : <Tag style={{ cursor: 'initial' }} color="volcano">{text}</Tag>)}/> */}

      <Column
        title="Actions"
        dataIndex="actions"
        key="actions"
        className="alignCenter"
        render={(text, record) => {
          // if (record.role !== 'admin') return <span />
          return (
            <span>

              {/* <B claname="UEbtn" style={user_button}>
                 <Link to={ROUTES.PAYMENT_USERS.replace(':id', record.id)}>
                   <p>Users</p>
                 </Link>
               </B> */}
              <B style={edit_button}>
                <Link to={ROUTES.PAYMENT_EDIT.replace(':id', record.id)}>
                  Edit
                </Link>
              </B>

              {/* <B className="UEbtn" onClick={()=>props.showProfileModal(record.id)} style={{ fontSize: '13px',backgroundColor: '#F3F3F3', borderColor: '#d9d9d9', color: 'black'}}>Profile</B> */}
              {/* <ProfileSelModal isVisible={props.visibleProfileModal === record.id} onCancel={props.hideProfileModal} profile_values={null} /> */}
              <Popconfirm
                title="Are you sure delete this company?"
                onConfirm={() => props.deleteCompany(record.id)}
                okText="Yes"
                cancelText="No"
              >
                <B className="UEbtn" style={{ backgroundColor: '#C94D4D', borderColor: '#d9d9d9', fontSize: '13px', color: 'white', marginLeft: '-2px' }}>Delete</B>
              </Popconfirm>
            </span>
          )
        }}
      />
    </Table>
  </Content>

export class PaymentListContainer extends React.Component {
  state = { searchText: '',}
  constructor(props){
    super(props);
    this.state={varify:0,Pending:0,paid:0};
    // this.data = get(this.props, 'data.viewer.paidcustomer.edges', []);
  }

  componentDidUpdate(prevProps){
    if (this.props.data !== prevProps.data) {
      const data = get(this.props, 'data.viewer.paidcustomer.edges', []);
      const count = {verify:0, Pending:0, paid:0}

      data.forEach(item => {
        if(item.status in count){
          count[item.status] += 1;
        }
      });

      this.setState(count);
    }
  }

  showProfileModal = id => {
    this.setState({ visibleProfileModal: id })
    //message.success('showProfileModal : ' + id)
  }
  hideProfileModal = () => {
    this.setState({ visibleProfileModal: null })
    //message.success('hideProfileModal : ')
  }
  deleteCompany = async id => {
    try {
      await this.props.mutate(id)
      message.success('Company has been deleted!')
    } catch (e) {
      message.error(e.graphQLErrors[0].message)
    }
  }
  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  render() {
    let com = get(this.props, 'data.viewer.paidcustomer.edges', []);
    const formattedData = com.map(item => ({
      ...item,
      payment_date: new Date(parseInt(item.payment_date)).toLocaleDateString('en-GB'),
      expire_date: new Date(parseInt(item.expire_date)).toLocaleDateString('en-GB'),
      // statusColor: getStatusColor(item.status),
    }));
    
    



    console.log("formattedDate.....",formattedData);
    console.log("this.props.form")
    console.log(this.props.form)
    console.log(this.form)
    console.log("date___check:",get(this.props, 'data.viewer.paidcustomer.edges'));
    console.log("com....",this.state.com);
    return (


      <PaymentList
        showProfileModal={this.showProfileModal}
        hideProfileModal={this.hideProfileModal}
        visibleProfileModal={this.state.visibleProfileModal}
        // companies={get(this.props, 'data.viewer.paidcustomer.edges')}
        formattedData ={formattedData}
        deleteCompany={this.deleteCompany}
        handleSearch={this.handleSearch}
        handleReset={this.handleReset}
        searchText={this.state.searchText}
        paid={this.state.paid}
        verify={ this.state.verify}
        pending={this.state.Pending}
      />
    )
  }
}

const paymentQueryConfig = {
  options: { variables: {} },
}
const paymentDeleteMutationConfig = {
  props: ({ mutate }) => {
    return {
      mutate: async id => {
        await mutate({
          variables: { id },
          refetchQueries: [
            {
              query: gql(Payment_logQuery),
            },
          ],
        })
      },
    }
  },
}
export default compose(
  graphql(gql(Payment_logQuery), paymentQueryConfig),
  graphql(gql(PaymentDeleteMutation), paymentDeleteMutationConfig)
)(PaymentListContainer)
